<sq-modal [title]="'msg#help.title'">
    <div class="d-flex flex-column">
        <iframe [src]="url"></iframe>
    </div>
</sq-modal>